module.exports = __webpack_public_path__ + "static/img/bg60.94e3d0da.png";